import BR from 'country-flag-icons/react/3x2/BR'
import DE from 'country-flag-icons/react/3x2/DE'
import ES from 'country-flag-icons/react/3x2/ES'
import FR from 'country-flag-icons/react/3x2/FR'
import IT from 'country-flag-icons/react/3x2/IT'
import US from 'country-flag-icons/react/3x2/US'

import { cn } from '@/lib/utils'

type FlagCode = 'us' | 'br' | 'es' | 'fr' | 'de' | 'it'

interface LanguageFlagProps {
  code: FlagCode
  className?: string
}

const flagComponents: Record<FlagCode, React.FC<{ title?: string }>> = {
  us: US,
  br: BR,
  es: ES,
  fr: FR,
  de: DE,
  it: IT,
}

export function LanguageFlag({ code, className }: LanguageFlagProps) {
  const FlagComponent = flagComponents[code]

  return (
    // Flex-centred with the SVG filling the box: the 3:2 flag letterboxes
    // inside any square container instead of hugging the top-left corner.
    <span
      className={cn(
        'inline-flex size-4 shrink-0 items-center justify-center overflow-hidden [&_svg]:h-full [&_svg]:w-full',
        className,
      )}
    >
      <FlagComponent />
    </span>
  )
}
